import React, { useState, useEffect, useRef } from 'react';
import { Radio, Checkbox } from 'antd';
import ResultStatements from './ResultStatements';
import FloatingButton from './FloatingButton';
import baseData from './questions.json';
import { _initdata, _quizdata, _question12Override } from '../RecoilState';
import { useRecoilState } from 'recoil';

const QuizComponent = () => {
    const [quizData, setQuizData] = useRecoilState(_quizdata);
    const [question12Override, setQuestion12Override] = useRecoilState(_question12Override);
    const [currentStage, setCurrentStage] = useState(0);
    const [textIndex, setTextIndex] = useState(0);
    const [showAnswers, setShowAnswers] = useState(false);
    const [selectedAnswers, setSelectedAnswers] = useState([]);
    const [quizCompleted, setQuizCompleted] = useState(false);
    const [answerHistory, setAnswerHistory] = useState([]);
    const [score, setScore] = useState({});
    const [initdata, setInitdata] = useRecoilState(_initdata);
    const modifiedQuestion12Ref = useRef(null);

    useEffect(() => {
        setTextIndex(0);
        setShowAnswers(false);
        setSelectedAnswers([]);
        console.log(question12Override);
    }, [currentStage]);

    useEffect(() => {
        if (quizCompleted) {
            calculateScores(answerHistory);
        }
    }, [answerHistory]);

    useEffect(() => {
        if (currentStage === 12 && modifiedQuestion12Ref.current) {
            setQuizData(prevData => {
                const newData = [...prevData];
                newData[12] = modifiedQuestion12Ref.current;
                return newData;
            });
        }
    }, [currentStage]);

    const currentItem = quizData && quizData[currentStage];

    if (!currentItem) {
        console.error("Current item is not available or quizData is empty.");
        return null;
    }

    const handleNext = () => {
        window.scrollTo(0, 0);


        if (textIndex < currentItem.text.length - 1) {
            setTextIndex(textIndex + 1);
        } else if (currentItem.type === 'question' && !showAnswers) {
            setShowAnswers(true);
        } else if (currentStage < quizData.length - 1) {
            if (currentItem.type === 'question') {
                updateAnswerHistory();
            }
            setCurrentStage(currentStage + 1);
        } else {
            if (currentItem.type === 'question') {
                updateAnswerHistory();
            }
            setQuizCompleted(true);
        }
    };

    const handlePrevious = () => {
        window.scrollTo(0, 0); // Add scroll to top
        if (currentItem.type === 'question') {
            setAnswerHistory(prevHistory =>
                currentItem.qtype === 'Multiple'
                    ? prevHistory.slice(0, prevHistory.length - 2)
                    : prevHistory.slice(0, prevHistory.length - 1)
            );
        }

        if (textIndex > 0) {
            setTextIndex(textIndex - 1);
        } else if (currentStage > 0) {
            setCurrentStage(currentStage - 1);
            setTextIndex(quizData[currentStage - 1].text.length - 1);
            setShowAnswers(quizData[currentStage - 1].type === 'question');
        }
    };

    const handleAnswerSelect = (value) => {
        if (currentItem.id === "8") {
            const selectedPositions = Array.isArray(value)
                ? value.map(val => {
                    const index = currentItem.answers.findIndex(a => a.option === val);
                    return index !== -1 ? index : null;
                }).filter(pos => pos !== null)
                : (() => {
                    const index = currentItem.answers.findIndex(a => a.option === value);
                    return index !== -1 ? [index] : [];
                })();

            console.log(`Selected Positions for quizData[8]:`, selectedPositions);
            handleSpecialCase(selectedPositions[0]);
        }

        if (currentItem.qtype === 'Single') {
            setSelectedAnswers([value]);
        } else {
            setSelectedAnswers(value);
        }
    };

    const handleSpecialCase = (selectedPosition) => {
        if (currentItem.id === "8") {
            const selectedAnswer = currentItem.answers[selectedPosition];
            if (!selectedAnswer) {
                console.error("Invalid position selected.");
                return;
            }

            const tobemodified = initdata[12].answers[selectedPosition];
            console.log(tobemodified)

            setQuestion12Override({
                id: "12",
                title: "Career Choice",
                type: "question",
                stage: "5",
                qtype: "Single",
                text: [tobemodified.option],
                answers: tobemodified.careers
            });
        }
    };

    const updateAnswerHistory = () => {
        const newAnswers = selectedAnswers.map(answer => {
            const answerObj = currentItem.answers.find(a => a.option === answer);
            return {
                title: currentItem.title,
                option: answer,
                score: answerObj ? answerObj.score : 0,
            };
        });

        if (currentStage === 12 && question12Override) {
            const overrideAnswers = selectedAnswers.map(answer => {
                const answerObj = question12Override.answers.find(a => a.option === answer);
                return {
                    title: question12Override.title,
                    option: answer,
                    score: answerObj ? answerObj.score : 0,
                };
            });
            setAnswerHistory([...answerHistory, ...newAnswers, ...overrideAnswers]);
        } else {
            setAnswerHistory([...answerHistory, ...newAnswers]);
        }
    };

    const calculateScores = (answers) => {
        console.log(answers);
        const result = {
            overall: 100, // Default score for "Bit Given At Birth"
            "Bit Given At Birth": 100, // Add the default line item
        };

        // Calculate scores for regular answers
        answers.forEach((answer) => {
            const score = typeof answer.score === 'number' ? answer.score : 0;
            result.overall += score;

            if (!result[answer.title]) {
                result[answer.title] = 0;
            }

            result[answer.title] += score;
        });

        // Handle question12Override if it exists
        if (question12Override) {
            const overrideAnswer = selectedAnswers.find(answer =>
                question12Override.answers.some(a => a.option === answer)
            );

            if (overrideAnswer) {
                const overrideScore = question12Override.answers.find(a =>
                    a.option === overrideAnswer
                )?.score || 0;

                if (!result[question12Override.title]) {
                    result[question12Override.title] = 0;
                }

                result[question12Override.title] += overrideScore;
                result.overall += overrideScore;
            }
        }

        setScore(result);
    };

    const renderContent = () => {
        const displayItem = currentStage === 12 && question12Override
            ? question12Override
            : currentItem;

        const imageGrid = (displayItem.isimage && Array.isArray(displayItem.image) && displayItem.image.length > 0)
            ? (
                <div className={displayItem.image.length === 1 ? 'flex justify-center' : displayItem.image.length === 2 ? 'grid grid-cols-1 md:grid-cols-2 gap-4 justify-center' : 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4'}>
                    {displayItem.image.map((gridItem, index) => (
                        <div key={index} className='flex flex-col items-center border p-2 rounded-md'>
                            <img
                                src={gridItem.grid_img}
                                alt={`grid-img-${index}`}
                                style={{ maxWidth: '100%', height: 'auto' }}
                            />
                            {gridItem.grid_txt && (
                                <p className='mt-2 brand-text text-[20px]' dangerouslySetInnerHTML={{ __html: gridItem.grid_txt }}></p>
                            )}
                        </div>
                    ))}
                </div>
            )
            : null;

        let textOrQuestionBlock = null;
        if (displayItem.type === 'content' && !imageGrid) {
            textOrQuestionBlock = <div className='brand-text question-content text-[20px]'
                dangerouslySetInnerHTML={{ __html: displayItem.text[textIndex] }}></div>;
        } else if (displayItem.type === 'question') {
            textOrQuestionBlock = (
                <div className='flex flex-col mt-4'>
                    <div className='brand-text question-content text-[20px]'
                        dangerouslySetInnerHTML={{ __html: displayItem.text[textIndex] }}></div>
                    {showAnswers && (
                        <div style={{ marginTop: 16 }}>
                            {displayItem.qtype === 'Single' ? (
                                <Radio.Group onChange={(e) => handleAnswerSelect(e.target.value)} value={selectedAnswers[0]}>
                                    {displayItem.answers.map((answer, index) => (
                                        <Radio className='mb-[15px] border-0 ml-[-10px]' key={index} value={answer.option}>
                                            <span className='brand-text text-[20px]'>{answer.option}</span>
                                        </Radio>
                                    ))}
                                </Radio.Group>
                            ) : (
                                <Checkbox.Group onChange={handleAnswerSelect} value={selectedAnswers}>
                                    {currentItem.answers.map((answer, index) => (
                                        <Checkbox
                                            className='mb-[15px]'
                                            key={index}
                                            value={answer.option}
                                            disabled={selectedAnswers.length >= 2 && !selectedAnswers.includes(answer.option)}
                                        >
                                            <span className='brand-text text-[20px]'>{answer.option}</span>
                                        </Checkbox>
                                    ))}
                                </Checkbox.Group>
                            )}
                        </div>
                    )}
                </div>
            );
        }

        return (
            <div>
                {imageGrid}
                {textOrQuestionBlock}
            </div>
        );
    };

    if (quizCompleted) {
        return (
            <div>
                <ResultStatements scoreData={score} />
            </div>
        );
    }

    const isFirstQuestion = currentStage === 0 && textIndex === 0;

    const shouldShowNextButton = () => {
        if (currentItem.type !== 'question') {
            return true;
        }
        if (!showAnswers) {
            return true;
        }
        if (currentItem.qtype === 'Single') {
            return selectedAnswers.length >= 1;
        }
        if (currentItem.qtype === 'Multiple') {
            return selectedAnswers.length >= 2;
        }
        return false;
    };

    return (
        <div className='border-[#92278F] px-[15px] py-[20px] rounded-[5px] border-[2px] brand-font '>
            <p className='text-center large-gradient-heading spacer'>
                {currentItem.title}
            </p>
            <div className='spacer'>
                {renderContent()}
            </div>
            {shouldShowNextButton() ? (
                <div className='flex flex-row justify-center pt-[30px] bg-transparent gap-10 brand-text font-bold'>
                    {/*
                    {!isFirstQuestion && (
                        <button
                            className='rotating-border-button-secondary'
                            onClick={handlePrevious}
                            disabled={true}
                        >
                            <p className='text-center text-[18px] font-bold'>
                                Previous
                            </p>
                        </button>
                    )}
                    */}
                    <button
                        className='rotating-border-button'
                        onClick={handleNext}
                        type="primary"
                    >
                        <p className='text-center gradient-small'>
                            {isFirstQuestion
                                ? 'Start'
                                : textIndex < currentItem.text.length - 1 || !showAnswers
                                    ? 'Next'
                                    : currentStage < quizData.length - 1
                                        ? 'Next Question'
                                        : 'Finish Quiz'}
                        </p>
                    </button>
                </div>
            ) : null}
            <FloatingButton answerHistory={answerHistory} currentStage={currentStage} quizData={quizData} />
        </div>
    );
};

export default QuizComponent;